import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Loader2 } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { api, errText } from "@/lib/api";
import { useAuth } from "@/lib/auth";

export const ProfileDialog = ({ open, onOpenChange }) => {
  const { user, setUser } = useAuth();
  const [mobile, setMobile] = useState(user.mobile || "");
  const [busy, setBusy] = useState(false);
  useEffect(() => { if (open) setMobile(user.mobile || ""); }, [open, user.mobile]);

  const save = async () => {
    setBusy(true);
    try {
      const r = await api.patch("/auth/profile", { mobile: mobile.trim() });
      setUser(r.data);
      toast.success("Mobile number updated");
      onOpenChange(false);
    } catch (e) { toast.error(errText(e)); }
    setBusy(false);
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-sm" data-testid="profile-dialog">
        <DialogHeader>
          <DialogTitle className="font-display">My profile</DialogTitle>
          <DialogDescription>Your mobile number prints on receipts next to your name.</DialogDescription>
        </DialogHeader>
        <div className="space-y-3">
          <div className="space-y-1.5">
            <Label className="text-xs text-slate-600">Name</Label>
            <Input value={user.name || ""} readOnly className="bg-plum-50" data-testid="profile-name" />
          </div>
          <div className="space-y-1.5">
            <Label className="text-xs text-slate-600">Email (sign-in)</Label>
            <Input value={user.email} readOnly className="bg-plum-50" data-testid="profile-email" />
            <p className="text-[11px] text-slate-500">Ask an admin if your email needs to change.</p>
          </div>
          <div className="space-y-1.5">
            <Label className="text-xs text-slate-600">Mobile number</Label>
            <Input type="tel" value={mobile} onChange={(e) => setMobile(e.target.value)} placeholder="+91 98765 43210" data-testid="profile-mobile-input" />
          </div>
          <Button onClick={save} disabled={busy || mobile.replace(/\D/g, "").length < 10} className="w-full bg-plum-700 hover:bg-plum-800" data-testid="profile-save-btn">
            {busy && <Loader2 className="mr-2 h-4 w-4 animate-spin" />}Save
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
};
